export const links = [
  { label: 'Über uns', href: '/uber-uns' },
  { label: 'Prozess', href: '/prozess' },
  { label: 'Arbeit', href: '/arbeit' },
  { label: 'Karrieren', href: '/karrieren' },
  { label: 'Kontakt', href: 'mailto:contact@thegoodcode.io' }
]
